export default __webpack_public_path__ + "static/media/me.e8299fad.png";